// src/components/RollingPicker.js
import React, { useMemo } from "react";
import Picker from "react-mobile-picker";
import "./RollingPicker.css";

/**
 * Reusable single-wheel picker.
 *
 * Props:
 * - name: string (key used by react-mobile-picker column)
 * - label: string (e.g. "Reps")
 * - options: string[] (values)
 * - value: string (selected value)
 * - unit: string (e.g. "reps", "kg") optional
 * - onValueChange: (nextValueString) => void
 */
export default function RollingPicker({
  name,
  label,
  options = [],
  value,
  unit,
  onValueChange,
}) {
  const valueStr = String(value ?? "");
  //const selectedIdx = useMemo(() => options.indexOf(valueStr), [options, valueStr]);

  // react-mobile-picker expects an object keyed by column name
  const pickerValue = useMemo(() => ({ [name]: valueStr }), [name, valueStr]);

  return (
    <div className="pc-wheel--col">
      {label ? <div className="pc-wheel-label">{label}</div> : null}

      <div className="pc-wheel-wrap">
        <div className="pc-highlight" aria-hidden="true" />

        <Picker
          value={pickerValue}
          onChange={(next) => onValueChange?.(next?.[name])}
          wheelMode="natural"
        >
          <Picker.Column name={name}>
            {options.map((opt, i) => {
              return (
                <Picker.Item key={`${name}-${opt}`} value={opt}>
                  <div className="pc-item">
                    {opt}
                    {unit ? <span className="pc-unit"> {unit}</span> : null}
                  </div>
                </Picker.Item>
              );
            })}
          </Picker.Column>
        </Picker>
      </div>
    </div>
  );
}